import React from 'react';
import styled from 'styled-components';
import FullScreenCard from '../FullScreenCard';
import BaseCard from '../BaseCard';
import Image from '../../Image';

const Container = styled(FullScreenCard)`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-direction: column;
  background-color: white;
  z-index: 1000;
`;

const Header = styled(BaseCard)`
  padding: 16px 24px;
`;

const CloseImage = styled(Image)`
  cursor: pointer;
`;

const Body = styled(BaseCard)`
  flex: 1;
  padding: 12px 24px 24px;
  overflow-y: scroll;
`;

const ModalFullScreenCard = ({ children, closeAction, show }) => (
  <Container show={show}>
    <Header>
      <CloseImage src="ic-outline-close-24.svg" onClick={closeAction} />
    </Header>
    <Body>{children}</Body>
  </Container>
);

export default ModalFullScreenCard;
